<template>
    <div class="benefitBoxes">
        <lazy-load-component :enabled="false" class="benefitBoxes__content" root-margin="0px 0px 0px 0px" @loaded="loadData()">
            <a v-for="(item, index) in benefits" :key="index" class="benefitBoxes__item" :href="item.url">
                <picture class="benefitBoxes__picture" data-not-lazy>
                    <!-- locale remove after release CZ/SK -->
                    <!--                    <source :srcset="`/nuxt-assets/images/icons/benefits/${item.img}-x2.png 2x`" data-not-lazy />-->
                    <img :src="`${item.img}`" data-not-lazy :alt="item.title.replace(/<[^>]*>?/gm, '')" />
                </picture>
                <div class="benefitBoxes__icon">
                    <img
                        :src="`/nuxt-assets/images/icons/benefits/${item.icon}`"
                        data-not-lazy
                        :alt="item.title.replace(/<[^>]*>?/gm, '')"
                        :width="item.width"
                        :height="item.height"
                    />
                </div>
                <span class="benefitBoxes__title" v-html="item.title"></span>
            </a>
        </lazy-load-component>
    </div>
</template>

<script lang="ts">
import LazyLoadComponent from '~/components/LazyLoadComponent.vue'

export default {
    components: {
        LazyLoadComponent,
    },
    data() {
        return {
            benefits: [
                {
                    url: this.$t('benefitsHomepage.benefit1.url'),
                    img: this.$t('benefitsHomepage.benefit1.img'),
                    icon: this.$t('benefitsHomepage.benefit1.icon'),
                    title: this.$t('benefitsHomepage.benefit1.title'),
                    width: 26,
                    height: 23,
                },
                {
                    url: this.$t('benefitsHomepage.benefit2.url'),
                    img: this.$t('benefitsHomepage.benefit2.img'),
                    icon: this.$t('benefitsHomepage.benefit2.icon'),
                    title: this.$t('benefitsHomepage.benefit2.title'),
                    width: 27,
                    height: 23,
                },
                {
                    url: this.$t('benefitsHomepage.benefit3.url'),
                    img: this.$t('benefitsHomepage.benefit3.img'),
                    icon: this.$t('benefitsHomepage.benefit3.icon'),
                    title: this.$t('benefitsHomepage.benefit3.title'),
                    width: 26,
                    height: 25,
                },
                {
                    url: this.$t('benefitsHomepage.benefit4.url'),
                    img: this.$t('benefitsHomepage.benefit4.img'),
                    icon: this.$t('benefitsHomepage.benefit4.icon'),
                    title: this.$t('benefitsHomepage.benefit4.title'),
                    width: 20,
                    height: 24,
                },
            ],
            loaded: false,
        }
    },
    methods: {
        loadData() {
            this.loaded = true
        },
    },
}
</script>

<style lang="scss" scoped>
.benefitBoxes {
    width: 100%;

    &--top {
        margin-top: -30px;
        position: relative;
        z-index: 3;
        margin-bottom: 2em;
        padding: 0 10px;

        @media (min-width: $max-width-container-inside) {
            margin-top: -40px;
        }
    }
}

.benefitBoxes__content {
    width: calc(100% + 2 * $padding-container-inside-mobile);
    margin-left: -$padding-container-inside-mobile;
    padding-left: $padding-container-inside-mobile;
    display: flex;
    overflow-x: auto;
    padding-top: 10px;
    padding-bottom: 10px;

    @include screen-sm {
        width: calc(100% + (2 * $padding-container-inside));
        margin-left: -$padding-container-inside;
        padding-left: $padding-container-inside;
    }

    @media (min-width: $max-width-container-inside) {
        width: 100%;
        max-width: $max-width-container-inside;
        padding-left: 0;
        margin: 0 auto;
        justify-content: space-between;
        overflow: visible;
    }
}

.benefitBoxes__item {
    display: block;
    height: 126px;
    min-width: 252px;
    position: relative;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: $box-shadow;
    margin-right: $padding-container-inside-mobile;
    background-color: $color-white;

    &:hover {
        @include screen-lg {
            box-shadow: $box-shadow-hover;
        }
    }

    @include screen-sm {
        margin-right: $padding-container-inside;
        height: 152px;
        min-width: 305px;
    }

    @media (min-width: $max-width-container-inside) {
        margin-right: 0;
        width: 24%;
    }
}

.benefitBoxes__picture {
    width: 163px;
    height: 126px;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;

    @include screen-sm {
        width: 197px;
        height: 152px;
    }
}

.benefitBoxes__icon {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background-color: $color-cta-extra-light;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0 0 15px;
}

.benefitBoxes__title {
    color: $color-dark;
    font-weight: 600;
    font-size: 13px;
    line-height: 17px;
    margin: 10px 0 0 15px;
    width: 48%;
    display: block;
    text-align: left;
    position: relative;
    z-index: 2;

    @media (min-width: 500px) {
        font-size: 16px;
        line-height: 21px;
    }
}
</style>
